<template>
  <div>
    <div class="pt-3 l-m-b-20 align-items-center d-flex justify-content-between blocks">
      <div class="d-flex align-items-center">
        <h1 class="pr-3">User roles</h1>
      </div>
      <div class="text-right">
        <router-link to="/settings/user-roles/create"
                     tag="button"
                     class="btn btn-primary"
                     v-if="$_can('carriers.roles.store')"
        >
          ADD USER ROLE
        </router-link>
      </div>
    </div>
    <template v-if="!roles">
      <vue-content-loading :width="800" :height="450">
        <rect v-for="x in 15" :key="x" x="10" :y="15*x*1.4" rx="5" ry="5" width="720" height="6" />
      </vue-content-loading>
    </template>
    <template v-else>
      <div class="blocks">
        <SettingsUserRolesBlock
          v-for="(role, index) in roles" :key="index"
          :role.sync="role"
        />
      </div>
      <div class="row blocks">
        <div class="col-sm-6 mb-1 text-black-50 pl-0"
             v-if="meta.total"
        >
          Showing {{ meta.from }} - {{ meta.to }} of {{ meta.total }}
        </div>
        <pagination class="col-sm-6 mb-1 pr-0" :change-page="changePage" :meta="meta" />
      </div>
    </template>
  </div>
</template>

<script>
import axios from 'axios';
import { mapState, mapActions } from 'vuex';
import Pagination from '../../Pagination';
import Errors from '../../../classes/Errors';
import SettingsUserRolesBlock from './SettingsUserRolesBlock';

export default {
  name: 'Roles',
  components: {
    SettingsUserRolesBlock,
    Pagination,
  },
  data: () => ({
    filterBy: 'area-code',
    value: '',
    departments: [],
    sortOrders: [],
    role: {
      name: '',
      permissions_ids: '',
      company_carrier_id: 0,
      department: null,
      department_id: null,
    },
    availableRoles: [],
    step: 1,
    page: 1,
    errors: new Errors(),
  }),
  computed: {
    ...mapState({
      roles: state => state.roles.paginatedRoles,
      meta: state => state.roles.paginatedRolesMeta,
    }),
  },
  mounted() {
    this.getPaginatedRoles(this.page);
    this.getDepartments();
  },
  methods: {
    ...mapActions(['getPaginatedRoles']),
    changePage(pageNum) {
      this.page = pageNum;
      this.getPaginatedRoles(this.page);
    },
    getDepartments() {
      axios
        .get('/values/departments')
        .then(res => {
          this.departments = res.data.data;
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    selectNumber(phone) {
      this.phone = phone;
      this.step = 3;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/settings/UserRoles/SettingsUserRoles.vue